import React, { useEffect } from "react";
import { Button } from "../Button";
import "./Card.scss";
import CardProps from "./Card.types";
import SelectBox from "../SelectBox/SelectBox";
import { Input } from "../Input";
import PropTypes from "prop-types";
import { Text } from "../Text";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Loader from "../../utilities/Loader";
const DATA_NOT_FOUND = ["No Data Found"];
const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "0.8em",
        height: "0.8em",
      },
    },
  })
);
const location = ["P1", "P2", "P3", "P4"];
const editDatas = [
  {
    cardType: "editMarkAttendanceCard",
    data: {
      selectLabel: "Reinforcement Contractor*",
      selectDropdown: ["Ram", "Sham", "Naveen"],
      LocationDropdown: ["Vijay Nagar", "JP Nagar", "Rajaji Nagar"],
      laborType: "Supply Labor",
      Date: "04 Apr, 2022",
    },
  },
  {
    cardType: "editMarkAttendanceCard",
    data: {
      selectLabel: "Concrete Contractor*",
      selectDropdown: ["Ram", "Sham", "Naveen"],
      LocationDropdown: ["Vijay Nagar", "JP Nagar", "Rajaji Nagar"],
      laborType: "Supply Labor",
      Date: "04 Apr, 2022",
    },
  },
  {
    cardType: "editMarkAttendanceCard*",
    data: {
      selectLabel: "Supply Contractor",
      selectDropdown: ["Ram", "Sham", "Naveen"],
      LocationDropdown: ["Vijay Nagar", "JP Nagar", "Rajaji Nagar"],
      laborType: "Supply Labor",
      Date: "04 Apr, 2022",
    },
  },
];

// cards in array
const CardList = ({
  cardData,
  edit,
  editCardItem,
  call,
  reset,
  resetSelectData,
  showEditBtn,
  editData,
  getEditData,
  functionEditCall,
  userIndex,
  showSubmitBtn,
  submitBtnLoad,
  locationArray,
}: any) => {
  //listing card for marked attendance list
  const classes = useStyles();
  const [hideEdit, setHideEdit] = React.useState(edit); //show or hide edit section
  const [list, setList] = React.useState(cardData); //list from the api
  const [displayDate, setDisplayDate] = React.useState<string>();
  const [displayTime, setDisplayTime] = React.useState<string>();
  const [mainContractor, setMainContractor] = React.useState<string>("");
  const [clientName, setClientName] = React.useState<string>("");
  const [totalLabors, setTotalLabors] = React.useState<string>("");
  const [mainContractorError, setMainContractorError] = React.useState(false);
  const [clientNameError, setClientNameError] = React.useState(false);
  const [totalLaborsError, setTotalLaborsError] = React.useState(false);
  // const [modalOpen, setModalOpen] = React.useState(false);
  const [radioBtnError, setRadioBtnError] = React.useState(false);
  const [radioBtnVal, setRadioBtnVal] = React.useState("day");
  const [laborLocation, setLaborLocation] = React.useState("");
  const [contractorName, setContractorName] = React.useState("");
  const [modalImage, setModalImage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [showImage, setShowImage] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState("");
  const [imageText, setImageText] = React.useState("");
  const [contractorError, setContractorError] = React.useState<any>("primary");
  const [locationError, setLocationError] = React.useState<any>("primary");
  const [role, setRole] = React.useState<any>("");
  const [resetSelect, setResetSelect] = React.useState(false);
  const [editBtn, setEditBtn] = React.useState(showEditBtn);
  const [radioChecked, setRadioChecked] = React.useState(false);
  const [editContractorValue, setEditContractorValue] = React.useState("");
  const [editLocationValue, setEditLocationValue] = React.useState("");
  const [editFunc, setEditFunc] = React.useState(false);
  const [editId, setEditId] = React.useState("");
  const [submitBtn, setSubmitBtn] = React.useState(true);
  const [contractorId, setContractorId] = React.useState("");
  const [locationData, setLocationData] = React.useState([]);
  const [mainContractorLengthErr, setMainContractorLengthErr] =
    React.useState(false);
  const [clientNameLengthErr, setClientNameLengthErr] = React.useState(false);
  const [submitButtonLoading, setSubmitButtonLoading] = React.useState(false);
  const alphaNumbericRegex = /^[a-zA-Z0-9\s]{0,}$/;
  //showing submit button based on checking present date attendance
  useEffect(() => {
    setSubmitBtn(showSubmitBtn);
  }, [showSubmitBtn]);

  useEffect(() => {
    if (locationArray?.length > 0) {
      setLocationData(locationArray);
    }
  }, [locationArray]);

  useEffect(() => {
    setHideEdit(edit);
  }, [edit]);

  useEffect(() => {
    setList(cardData);
    // data.forEach((val: any) => {
    if (cardData?.edit) {
      setEditContractorValue(cardData?.data?.["Contractor Name"]);
      setContractorName(cardData?.data?.["Contractor Name"]);
      setRadioBtnVal(cardData?.shiftType);
      setEditLocationValue(cardData?.data?.["Labor Location"]);
      setLaborLocation(cardData?.data?.["Labor Location"]);
      setMainContractor(
        cardData?.data?.["Main Contractor Representative Name"]
      );
      setClientName(cardData?.data?.["Client Representative Name"]);
      setTotalLabors(cardData?.data?.["Available Labor"]);
      setEditId(cardData?._id);
      setContractorId(cardData?.contractorId);
    }
    // });
  }, [cardData]);

  useEffect(() => {
    setSubmitButtonLoading(submitBtnLoad);
  }, [submitBtnLoad]);

  useEffect(() => {
    // let data: any = [];
    // if (getEditData?.length > 0) {
    if (cardData?.edit === true) {
      setEditContractorValue(cardData?.data?.["Contractor Name"]);
      setContractorName(cardData?.data?.["Contractor Name"]);
      setRadioBtnVal(cardData?.shiftType);
      setEditLocationValue(cardData?.data?.["Labor Location"]);
      setLaborLocation(cardData?.data?.["Labor Location"]);
      setMainContractor(
        cardData?.data?.["Main Contractor Representative Name"]
      );
      setClientName(cardData?.data?.["Client Representative Name"]);
      setTotalLabors(cardData?.data?.["Available Labor"]);
      setEditId(cardData?._id);
      setContractorId(cardData?.contractorId);
    }
  }, [getEditData]);

  useEffect(() => {
    setEditBtn(showEditBtn);
  }, [showEditBtn]);
  useEffect(() => {
    //reset the card form after successfull submission
    if (reset) {
      setResetSelect(true);
      setMainContractor("");
      setClientName("");
      setTotalLabors("");
      setRadioBtnVal("");
      setContractorName("");
      setLaborLocation("");
      setRadioBtnVal("");
      setRadioChecked(false);
      // setHideEdit(false);
    }
  }, [reset]);
  useEffect(() => {
    const day = new Date().toLocaleString("en-US", { day: "2-digit" }); // day in 2 digit format
    const month = new Date().toLocaleString("en-US", { month: "short" }); //month in short format
    const year = new Date().toLocaleString("en-US", { year: "numeric" }); // year in number format

    const date = `${day}${" "}${month}${", "}${year}`; // all date variables in one
    let hours = new Date().getHours();
    let minutes: any = new Date().getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm; // time in 12 hr format
    setDisplayDate(date);
    setDisplayTime(strTime);
  }, []);

  const laborLocationFn = (e: any) => {
    setLaborLocation(e.target.value);
  };
  const handleChange = (e: any, type: any) => {
    if (radioBtnVal.length == 0) {
      setRadioBtnError(true);
    } else {
      setRadioBtnError(false);
    }
    if (contractorName.length == 0) {
      setContractorError("danger");
    } else {
      setContractorError("primary");
    }
    if (laborLocation.length == 0) {
      setLocationError("danger");
    } else {
      setLocationError("primary");
    }
    if (mainContractor.length == 0) {
      setMainContractorError(true);
    } else {
      setMainContractorError(false);
    }
    if (clientName.length == 0) {
      setClientNameError(true);
    } else {
      setClientNameError(false);
    }
    if (totalLabors.length == 0) {
      setTotalLaborsError(true);
    } else {
      setTotalLaborsError(false);
    }
    if (mainContractor.length < 3) {
      return;
    }
    if (clientName.length < 3) {
      return;
    }

    if (
      mainContractor.length > 2 &&
      clientName.length > 2 &&
      totalLabors.length > 0 &&
      radioBtnVal.length > 0 &&
      contractorName.length > 0 &&
      laborLocation.length > 0
    ) {
      setOpen(true);
      let obj = {};
      setModalTitle("Are you sure You Want to Mark the attendance?");
      if (role === "Reinforcement Contractor") {
        obj = {
          laborLocation: laborLocation,
          mainContractor: mainContractor,
          clientName: clientName,
          availableLabour: totalLabors,
          role: "sub-contractor",
          roleType: "reinforce-contractor",
          contractorName: contractorName,
          shift: radioBtnVal,
        };
        call(obj);
      } else if (role === "Concrete Contractor") {
        obj = {
          role: "sub-contractor",
          contractorName: contractorName,
          shift: radioBtnVal,
          laborLocation: laborLocation,
          mainContractor: mainContractor,
          clientName: clientName,
          availableLabour: totalLabors,
          roleType: "concrete-contractor",
        };
        call(obj);
      } else {
        obj = {
          role: "sub-contractor",
          contractorName: contractorName,
          shift: radioBtnVal,
          laborLocation: laborLocation,
          mainContractor: mainContractor,
          clientName: clientName,
          availableLabour: totalLabors,
          roleType: "supply-labor-contractor",
        };
        call(obj);
      }
    }
  };

  const callEdit = () => {
    let role = "";
    if (radioBtnVal.length == 0) {
      setRadioBtnError(true);
    } else {
      setRadioBtnError(false);
    }
    if (contractorName.length == 0) {
      setContractorError("danger");
    } else {
      setContractorError("primary");
    }
    if (laborLocation.length == 0) {
      setLocationError("danger");
    } else {
      setLocationError("primary");
    }
    if (mainContractor.length == 0) {
      setMainContractorError(true);
    } else {
      setMainContractorError(false);
    }
    if (clientName.length == 0) {
      setClientNameError(true);
    } else {
      setClientNameError(false);
    }
    if (totalLabors.length == 0) {
      setTotalLaborsError(true);
    } else {
      setTotalLaborsError(false);
    }
    if (mainContractor.length < 3) {
      return;
    }
    if (clientName.length < 3) {
      return;
    }

    if (cardData.dropdownLabel === "Reinforcement Contractor") {
      role = "reinforce-contractor";
    } else if (cardData.dropdownLabel === "Concrete Contractor") {
      role = "concrete-contractor";
    } else if (cardData.dropdownLabel === "Supply Contractor") {
      role = "supply-labor-contractor";
    }
    if (
      mainContractor.length > 0 &&
      clientName.length > 0 &&
      totalLabors.toString().length > 0 &&
      radioBtnVal.length > 0 &&
      contractorName.length > 0 &&
      laborLocation.length > 0
    ) {
      let obj = {};
      obj = {
        id: editId,
        location: laborLocation,
        mainContractorRepresentative: mainContractor,
        clientRepresentative: clientName,
        availableLabour: parseInt(totalLabors),
        attendanceOf: contractorId,
        shift: radioBtnVal,
      };
      // call(obj)
      functionEditCall(obj);
    }
  };

  const send = () => {
    // setOpen(true)
    setShowImage(true);
    setModalImage("attendanceMarked");
    setModalTitle("Attendance Confirmation");
    setImageText("Attendance Marked Successfully!");
  };
  //calling reset method to reset the values in the selectbox component
  const changeReset = () => {
    setResetSelect(false);
    resetSelectData();
  };

  const editDataFromApi = (id: any) => {
    // editData(id);
    setHideEdit(true);
    setEditFunc(true);
  };

  const preventMinus = (e: any) => {
    console.log(e.code);
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  // const sendUserIndex = (ind: any, type: any) => {
  //   userIndex(ind, type);
  // };
  return (
    // mard and edit attendance card
    <div>
      {!hideEdit ? (
        <div>
          {cardData.cardType == "markAttendanceCard" && (
            <div className="card-noTopPadding">
              <div>
                <div
                  className={`top-left-box ${
                    cardData.shiftType == "day" ? "morning" : "night"
                  } shiftType fs-14 fw-500`}
                >
                  {cardData.shiftType == "day" ? "Day Shift" : "Night Shift"}
                </div>
                {cardData?.edit && (
                  <Button
                    isRounded={true}
                    className="rightBtn"
                    onClick={() => {
                      editDataFromApi(cardData._id);
                    }}
                  >
                    Edit
                  </Button>
                )}
              </div>
              <div className="float-container">
                {Object.entries(list.data)?.map(([key, value]: any, i) => (
                  <div key={i} className="mt">
                    {/* setting width of last index box to 100% */}
                    <div
                      className="mark-attendance"
                      style={i === 6 ? { width: "100%" } : { width: "50%" }}
                    >
                      <div className="key fw-400">{key}</div>
                      <div className="value fw-500 fs-14">{value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="card my-1">
            <SelectBox
              label={cardData.dropdownLabel}
              data={
                cardData?.contractorNames &&
                cardData?.contractorNames?.length > 0
                  ? cardData?.contractorNames
                  : DATA_NOT_FOUND
              }
              placeHolder="Select Contractor"
              onChange={(e: any) => {
                setContractorName(e.target.value);
                setRole(cardData.dropdownLabel);
                if (e.target.value.length > 0) {
                  setContractorError(false);
                } else {
                  setContractorError(true);
                }
                // const index = cardData.contractorNames
                //   ?.map((item: any) => item)
                //   .indexOf(e.target.value);
                // sendUserIndex(e.target.value, cardData.dropdownLabel);
                // console.log(index);
              }}
              borderColor={contractorError}
              resetVal={resetSelect}
              changeReset={() => changeReset()}
              defaultVal={contractorName}
            ></SelectBox>
            <div className="flex radio-margin">
              <div className="card-radio-container">
                <div
                  className={`margin fw-600 fs-14 ${
                    radioBtnError ? "color-red" : "color-black"
                  }`}
                >
                  Shift* :
                </div>
                <label className="custom-radio-btn">
                  <span className="label fs-14">Day</span>
                  <input
                    type="radio"
                    value="day"
                    name={userIndex}
                    id="r1"
                    checked={radioBtnVal === "day"}
                    onChange={(e) => {
                      if (e.target.value.length > 0) {
                        setRadioBtnError(false);
                      } else {
                        setRadioBtnError(true);
                      }
                    }}
                    defaultChecked
                    onClick={(e: any) => setRadioBtnVal(e.target.value)}
                  />
                  <span className="checkmark"></span>
                </label>

                <label className="custom-radio-btn">
                  <span className="label fs-14">Night</span>
                  <input
                    type="radio"
                    value="night"
                    name={userIndex}
                    checked={radioBtnVal === "night"}
                    id="r2"
                    onChange={(e) => {
                      if (e.target.value.length > 0) {
                        setRadioBtnError(false);
                      } else {
                        setRadioBtnError(true);
                      }
                    }}
                    onClick={(e: any) => setRadioBtnVal(e.target.value)}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="flex fs-14 mb-1">
              <div className="fw-600 fs-14">Date/Time:</div>&nbsp;
              <div className="fw-500">
                {editFunc ? (
                  <>
                    {cardData.data.Date} &nbsp; {cardData.time}
                  </>
                ) : (
                  <>
                    {displayDate} {displayTime}
                  </>
                )}
              </div>
            </div>
            <form>
              <div className="mb-1">
                <label>
                  <SelectBox
                    label={"Labor Location*"}
                    data={
                      locationData && locationData?.length > 0
                        ? locationData
                        : DATA_NOT_FOUND
                    }
                    placeHolder="Select Location"
                    onChange={(e: any) => {
                      laborLocationFn(e);
                      if (e.target.value.length > 0) {
                        setLocationError("primary");
                      } else {
                        setLocationError("danger");
                      }
                    }}
                    borderColor={locationError}
                    value={laborLocation}
                    resetVal={resetSelect}
                    changeReset={() => changeReset()}
                    defaultVal={laborLocation}
                  ></SelectBox>
                </label>
              </div>
              <label className="form-field mb-1">
                <div className="fw-600 mrb">
                  Main Contractor Representative Name*
                </div>
                <Input
                  color={mainContractorError ? "danger" : "primary"}
                  className="input-height"
                  onChange={(e) => {
                    if (alphaNumbericRegex.test(e.target.value)) {
                      setMainContractor(e.target.value);
                      if (e.target.value.length > 0) {
                        setMainContractorError(false);
                      } else {
                        setMainContractorError(true);
                      }
                      if (e.target.value.length < 3) {
                        setMainContractorLengthErr(true);
                      } else {
                        setMainContractorLengthErr(false);
                      }
                    }
                  }}
                  maxLength={20}
                  value={mainContractor}
                />
                {mainContractorError && (
                  <Text
                    type={`${mainContractorError ? "danger" : "normal"}`}
                    fonts="normal"
                    className={`m-0 fs-12`}
                  >
                    Main Contractor Name is Required
                  </Text>
                )}
                {mainContractorLengthErr && (
                  <Text
                    type={`${mainContractorLengthErr ? "danger" : "normal"}`}
                    fonts="normal"
                    className={`m-0 fs-12`}
                  >
                    Main Contractor Name must have 3 characters max
                  </Text>
                )}
              </label>
              <label className="form-field mb-1">
                <div className="fw-600 mrb">Client Representative Name*</div>
                <Input
                  color={clientNameError ? "danger" : "primary"}
                  className="input-height"
                  onChange={(e) => {
                    if (alphaNumbericRegex.test(e.target.value)) {
                      setClientName(e.target.value);
                      if (e.target.value.length > 0) {
                        setClientNameError(false);
                      } else {
                        setClientNameError(true);
                      }
                      if (e.target.value.length < 3) {
                        setClientNameLengthErr(true);
                      } else {
                        setClientNameLengthErr(false);
                      }
                    }
                  }}
                  maxLength={20}
                  value={clientName}
                />
                {clientNameError && (
                  <Text
                    type={`${clientNameError ? "danger" : "normal"}`}
                    fonts="normal"
                    className={`m-0 fs-12 ${clientNameError ? "" : "hidden"}`}
                  >
                    Client Name is Required
                  </Text>
                )}
                {clientNameLengthErr && (
                  <Text
                    type={`${clientNameLengthErr ? "danger" : "normal"}`}
                    fonts="normal"
                    className={`m-0 fs-12 ${
                      clientNameLengthErr ? "" : "hidden"
                    }`}
                  >
                    Client Name must have 3 characters max
                  </Text>
                )}
              </label>
              <label className="flex jc-sb mb-1">
                <div className="fw-600 w-50">
                  <div style={{ display: "block" }}>
                    Number of Labor Available*
                  </div>

                  {totalLaborsError && (
                    <Text
                      type={`${totalLaborsError ? "danger" : "normal"}`}
                      fonts="normal"
                      className={`m-0 fs-12 ${
                        totalLaborsError ? "" : "hidden"
                      }`}
                    >
                      Total Labors is Required
                    </Text>
                  )}
                </div>
                <div className="numberInputEnd w-50">
                  <Input
                    type="number"
                    color={totalLaborsError ? "danger" : "primary"}
                    className="input-height numberInput"
                    onChange={(e) => {
                      if (!/^\d{0,7}$/.test(e.target.value))
                          return false;
                      if (
                        Number(e?.target?.value) < 0 ||
                        e.target.value.search(/^0/) !== -1
                      ) {
                        return false;
                      } else {
                        setTotalLabors(e.target.value);
                      }
                      if (e.target.value.length > 0) {
                        setTotalLaborsError(false);
                      } else {
                        setTotalLaborsError(true);
                      }
                    }}
                    value={totalLabors}
                    onKeyPress={preventMinus}
                    min="1"
                    max="100"
                  />
                </div>
              </label>
            </form>
            <div className="flex jc-c">
              {/* {submitBtn ? ( */}
              <Button
                isRounded={true}
                onClick={(e: any) => {
                  editFunc
                    ? callEdit()
                    : handleChange(e, cardData.dropdownLabel);
                }}
              >
                {submitButtonLoading ? (
                  <Loader
                    color="white"
                    loading={submitButtonLoading}
                    size={10}
                    height="auto"
                  />
                ) : (
                  "Submit"
                )}
              </Button>
              {/* ) : (
                <div className="fs-14 fw-600 color">
                  Already Marked Attendance for Today!
                </div>
              )} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// main card
const Card = ({
  onChange,
  cardList,
  cardEdit,
  functionCall,
  showPileCard,
  resetData,
  resetSelectData,
  showEditBtn,
  editData,
  getEditData,
  functionEditCall,
  userIndex,
  showSubmitBtn,
  locationArray,
}: CardProps) => {
  return (
    <>
      {/* pile id info card */}
      {/* {falews } */}
      {showPileCard &&
        cardList &&
        cardList?.map((item: any, index: number) => (
          <div key={index}>
            {item?.cardType == "pileCard" && (
              <div className="card">
                <div className="pileId">Pile Id: {item?.pileId}</div>
                {Object.entries(item?.data).map(([key, val]: any, i) => (
                  <div key={i} className="flex">
                    <div className="child">
                      <div className="sub-data fs-14 fw-400">{key}</div>
                    </div>

                    <div className="child">
                      <div
                        className={`${
                          val == "work in progress"
                            ? "pile-work fw-600 shadow"
                            : val == "completed"
                            ? "pile-complete fw-600 shadow"
                            : val == "discarded"
                            ? "pile-discard fw-600 shadow"
                            : val == "completed with delay"
                            ? "pile-delay fw-600 shadow"
                            : "fw-600"
                        } sub-data ${
                          key === "Work Started on" ||
                          key === "Work Completed on"
                            ? "fs-13"
                            : "fs-14"
                        } capitalize`}
                      >
                        {val}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

      <CardList
        cardData={cardList}
        onChange={onChange}
        edit={cardEdit}
        call={functionCall}
        reset={resetData}
        resetSelectData={resetSelectData}
        showEditBtn={showEditBtn}
        editData={editData}
        getEditData={getEditData}
        functionEditCall={functionEditCall}
        userIndex={userIndex}
        showSubmitBtn={showSubmitBtn}
        locationArray={locationArray}
      />
    </>
  );
};

Card.propTypes = {
  onChange: PropTypes.func,
};

export default Card;
